import addToCollection from '../addToCollection';

const assembleReplacements  = (replacements = [], addedReplacements = []) => 
{
    let mergedReplacements = replacements;
    if (Array.isArray(addedReplacements)) 
    {
        mergedReplacements = [...addedReplacements, ...mergedReplacements];
    }
    return (domNode) => 
    {
        for (let ix = 0; ix < mergedReplacements.length; ix += 1) // NOSONAR
        {
            if ( typeof domNode.nodeType !== 'number' ) return null;
            const converted = mergedReplacements[ix](domNode, addToCollection);
            if (converted) return converted;
        }
        return null;
    };
};

export default assembleReplacements ;
